export const MANAGER = 1;
export const EMPLOYEE = 2;
export const EXECUTIVE = 3;
